module.exports = __webpack_public_path__ + "static/img/shape-al1.272bb11.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shape-al1.png
// module id = zw3n
// module chunks = 1